import React, { useState, useEffect } from 'react';
import { Button, CircularProgress, Box } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import ProfilForm from '../../../components/ProfilForm';
import themeNutriFast from '../../../styles/NutriFastColors';
import PageTransition from '../../../components/PageTransition';
import { TouchFeedback } from '../../../components/RippleEffect';
import { BounceClick } from '../../../components/MicroInteractions';
import { VisuallyHidden } from '../../../components/AccessibilityUtils';
import axios from 'axios';
import { getHeader } from '../../../service/auth';

const EditUsers = () => {
    const { state: locationState } = useLocation();
    const navigate = useNavigate();
    const [userData, setUserData] = useState(null);
    const [loading, setLoading] = useState(true);

    // Récupérer les données utilisateur au chargement
    useEffect(() => {
        const fetchUserData = async () => {
            if (locationState?.id) {
                try {
                    const headers = getHeader();
                    const response = await axios.get(`${process.env.REACT_APP_ADMIN}/user/${locationState.id}`, { headers });
                    const userInfo = response.data;

                    // Convertir name en username
                    if (userInfo.name && !userInfo.username) {
                        userInfo.username = userInfo.name;
                    }

                    // Gérer la date
                    if (userInfo.birth_date) {
                        userInfo.birth_date = dayjs(userInfo.birth_date);
                    }

                    setUserData(userInfo);
                } catch (error) {
                    console.error("Erreur:", error);
                }
            }
            setLoading(false);
        };

        fetchUserData();
    }, [locationState]);

    if (loading) {
        return (
            <PageTransition>
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                    <CircularProgress />
                </Box>
            </PageTransition>
        );
    }

    return (
        <PageTransition>
            <VisuallyHidden component="h1">
                Modifier les informations de l'utilisateur {userData?.name || userData?.username}
            </VisuallyHidden>

            <BounceClick>
                <TouchFeedback>
                    <Button
                        variant="outlined"
                        startIcon={<ArrowBack />}
                        onClick={() => navigate('/admin/gestion_user')}
                        aria-label="Retourner à la gestion des utilisateurs"
                        sx={{
                            color: themeNutriFast.palette.primary.dark,
                            borderColor: themeNutriFast.palette.primary.dark,
                            mb: 2,
                            '&:hover': {
                                backgroundColor: 'rgba(2, 62, 138, 0.04)',
                                borderColor: themeNutriFast.palette.primary.main
                            }
                        }}
                    >
                        Retour
                    </Button>
                </TouchFeedback>
            </BounceClick>

            <ProfilForm
                defaultValues={userData || {}}
                admin={true}
                onProfileUpdate={() => {
                    // Rediriger vers la liste des utilisateurs après modification réussie
                    navigate('/admin/gestion_user');
                }}
            />
        </PageTransition>
    );
};

export default EditUsers;